import taxExempt from './taxExempt';
import integrationsApisKeys from './integrationsApisKeys';

const partnerProfile = {}

partnerProfile.taxExempt = taxExempt;
partnerProfile.integrationsApisKeys = integrationsApisKeys;

export default partnerProfile
